import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";

// Swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { getallTestimonial } from "../../../utils/apis/Home/Homeapi";

const Testimonials = () => {
  const swiperRef = useRef(null);
  const notices = [
    {
      title: "Rishi Karekar",
      description:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      title: "Aditya Jagtap",
      description:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      title: "Prathamesh Raut",
      description:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      title: "Prathamesh Raut",
      description:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      title: "Prathamesh Raut",
      description:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const PerPage = 10;

  const [testimonial, setTestimonial] = useState();
  const getAllTestimonial = async () => {
    const res = await getallTestimonial({
      page: currentPage,
      per_page: PerPage
    });

    if (res?.success) {
      setTestimonial(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllTestimonial({});
  }, [currentPage]);


  const totalPages = testimonial?.total_pages || 1;

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  return (
    <section className="Testimonials">
      <div className="Testimonials_header">
        <p className="testimonial_title">Testimonials</p>
        <h5 className="testimonial_subtitle">Words from Our Passengers!</h5>
      </div>

      <div className="notice_section">
        <div className="container p-0">
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            breakpoints={{
              1200: { slidesPerView: 3 },
              992: { slidesPerView: 2.8 },
              768: { slidesPerView: 2.2 },
              575: { slidesPerView: 2 },
              0: { slidesPerView: 1.2 },
            }}
            className="notice_swiper"
          >

            {testimonial?.data?.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="notice_card">
                  <p className="notice_text">{item?.description || ""}</p>
                  <h6 className="notice_title">{item?.name || ""}</h6>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="custom_nav">
            <button
              className="nav_btn"
              onClick={handlePrev}
              disabled={currentPage === 1}            >
              <FontAwesomeIcon icon={faAngleLeft} className="font_angle" />
            </button>

            <button
              className="nav_btn right_angle_btn"
              onClick={handleNext}
              disabled={currentPage === totalPages}            >
              <FontAwesomeIcon icon={faAngleRight} className="font_angle" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
